<template>
    <form class="form-group" autocomplete="off" :class="{ 'has-error': hasError }" data-cy="auth-code" @submit.prevent>
        <input
            ref="input"
            v-model="val"
            class="auth-code-input"
            :class="{ empty: value.length === 0 }"
            :placeholder="Array(length + 1).join('0')"
            :maxlength="length"
            @input="updateValue($event.target.value)"
        />
        <p v-show="hasError" class="help-block" v-html="$t(errorText)"></p>
    </form>
</template>

<script>
export default {
    name: 'AuthCodeInput',
    props: {
        value: {
            type: String,
            default: '',
        },
        hasError: {
            type: Boolean,
            default: false,
            note: 'Show error text',
        },
        errorText: {
            type: String,
            default: '',
            note: 'Input error text or i18n key',
        },
        length: {
            type: Number,
            default: 6,
            note: 'Input auto code length',
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        preventRepeatFulfill: {
            type: Boolean,
            default: false,
            note: 'true 면 같은 값으로 여러 번 fulfill emit 하는 걸 막습니다',
        },
    },
    data() {
        return {
            val: '',
            lastFulfillValue: '',
        };
    },
    watch: {
        value: {
            handler(val = '') {
                if (val !== this.val) {
                    this.updateValue(val);
                }
            },
            immediate: true,
        },
    },
    mounted() {
        if (this.autofocus) this.$refs.input.focus();
    },
    methods: {
        updateValue(val) {
            const value = val
                .toString()
                .replace(/[\W]/g, '')
                .substr(0, this.length);

            this.val = value;
            this.$emit('input', value);

            if (value.length === this.length) {
                if (this.preventRepeatFulfill) {
                    if (value === this.lastFulfillValue) return;
                    this.lastFulfillValue = value;
                }
                this.$emit('fulfill');
            } else if (this.preventRepeatFulfill) {
                // 길이가 줄어들면 guard 초기화
                this.lastFulfillValue = '';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.auth-code-input {
    width: 100%;
    height: 50px;
    font-size: 24px;
    text-indent: 20px;
    letter-spacing: 20px;
    color: #d9d9d9;
    text-align: center;
    background: black;
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 3px;
    outline: none !important;
    text-transform: uppercase;
    &:focus,
    &:active {
        color: white;
    }
    &.empty {
        caret-color: transparent; // hide cursor
    }
}
.has-error {
    input:placeholder-shown {
        border: 2px solid #e63f57;
    }
}
/// Hide Arrows From Input Number
/* 	Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}
///
</style>
